// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1625px) {

    .Hardware-Ticket-Details_showHideMiniKnowledgebase__Wxil5 {
        display: none;
    }
  }
  

  .Hardware-Ticket-Details_standardRow__6clgT {
    background-color: transparent;
  }
  
  .Hardware-Ticket-Details_alternateLightRow__wxzRU {
    background-color: #D3D3D3; /* Mantine gray.1 or your choice */
  }

  .Hardware-Ticket-Details_alternateDarkRow__-DMN2 {
    background-color: #363737;
  }`, "",{"version":3,"sources":["webpack://./src/components/Hardware-Ticket-Details.module.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,aAAa;IACjB;EACF;;;EAGA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["@media only screen and (max-width: 1625px) {\n\n    .showHideMiniKnowledgebase {\n        display: none;\n    }\n  }\n  \n\n  .standardRow {\n    background-color: transparent;\n  }\n  \n  .alternateLightRow {\n    background-color: #D3D3D3; /* Mantine gray.1 or your choice */\n  }\n\n  .alternateDarkRow {\n    background-color: #363737;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showHideMiniKnowledgebase": `Hardware-Ticket-Details_showHideMiniKnowledgebase__Wxil5`,
	"standardRow": `Hardware-Ticket-Details_standardRow__6clgT`,
	"alternateLightRow": `Hardware-Ticket-Details_alternateLightRow__wxzRU`,
	"alternateDarkRow": `Hardware-Ticket-Details_alternateDarkRow__-DMN2`
};
export default ___CSS_LOADER_EXPORT___;
